export class UnitReferenceModel {
    public unitCode: string;
    public unitName: string;
}